import { get, post } from "../http-client/client";
import { ApiResponse } from "../http-client/Response";

export interface CreateFeedbackRequest {
  formVersion: string;
  responses: Record<string, any>;
}

export interface FeedbackSubmission {
  id: string;
  formVersion: string;
  responses: Record<string, any>;
  userId: string;
  organizationId: string;
  createdAt: string;
  updatedAt: string;
  subscriptionExtended?: boolean;
}

export interface FeedbackWithUser extends FeedbackSubmission {
  userEmail: string;
}

export const submitFeedback = (data: CreateFeedbackRequest): Promise<ApiResponse<FeedbackSubmission>> => {
  return post(`/feedback`, data);
};

export const getAllFeedback = (): Promise<ApiResponse<FeedbackWithUser[]>> => {
  return get(`/feedback`, null);
};
